import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { UserAuthProvider, useUserAuth } from './contexts/UserAuthContext';
import { AdminAuthProvider, useAdminAuth } from './contexts/AdminAuthContext';
import { GlobalStyle } from './styles/GlobalStyles';
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import AdminDashboard from './components/AdminDashboard';
import AdminLogin from './components/AdminLogin';

// Componente para proteger rotas de usuários
const UserProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentUser, loading } = useUserAuth();
  
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Carregando...
      </div>
    );
  }
  
  // Se não há usuário autenticado, redireciona para login
  if (!currentUser) {
    return <Navigate to="/" replace />;
  }
  
  // Se o usuário está autenticado mas não tem OSC cadastrada, redireciona para login
  if (!currentUser.oscData) {
    
    return <Navigate to="/" replace />;
  }
  
  return <>{children}</>;
};

// Componente para proteger rotas administrativas
const AdminProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentUser, loading } = useAdminAuth();
  
  
  
  
  
  if (loading) {
    
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Carregando...
      </div>
    );
  }
  
  if (!currentUser) {
    
    return <Navigate to="/admin" replace />;
  }
  
  
  return <>{children}</>;
};

// Componente principal da aplicação para usuários
const UserApp: React.FC = () => {
  const { currentUser, loading } = useUserAuth();
  const [showRegister, setShowRegister] = useState(false);
  const [prefilledCnpj, setPrefilledCnpj] = useState('');
  const [registerCnpj, setRegisterCnpj] = useState('');

  const handleSwitchToLogin = (cnpj?: string) => {
    setShowRegister(false);
    setRegisterCnpj('');
    if (cnpj) {
      setPrefilledCnpj(cnpj);
    }
  };

  const handleSwitchToRegister = (cnpj?: string) => {
    setShowRegister(true);
    setPrefilledCnpj('');
    if (cnpj) {
      setRegisterCnpj(cnpj);
    }
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Carregando...
      </div>
    );
  }

  if (currentUser) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <>
      {showRegister ? (
        <Register 
          onSwitchToLogin={handleSwitchToLogin} 
          prefilledCnpj={registerCnpj}
          onCnpjUsed={() => setRegisterCnpj('')}
        />
      ) : (
        <Login 
          onSwitchToRegister={handleSwitchToRegister} 
          prefilledCnpj={prefilledCnpj}
          onCnpjUsed={() => setPrefilledCnpj('')}
        />
      )}
    </>
  );
};

function App() {
  return (
    <UserAuthProvider>
      <AdminAuthProvider>
        <Router>
          <GlobalStyle />
          <Routes>
            {/* Rota principal */}
            <Route path="/" element={<UserApp />} />
            
            {/* Rota do dashboard principal */}
            <Route 
              path="/dashboard" 
              element={
                <UserProtectedRoute>
                  <Dashboard />
                </UserProtectedRoute>
              } 
            />
            
            {/* Rotas administrativas */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route 
              path="/admin/dashboard" 
              element={
                <AdminProtectedRoute>
                  <AdminDashboard />
                </AdminProtectedRoute>
              } 
            />
            
            {/* Rota de fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AdminAuthProvider>
    </UserAuthProvider>
  );
}

export default App;
